module.exports = __webpack_public_path__ + "img/f1444b7.svg";